export function setAuthInfo(data) {
  return {
    type: 'SET_AUTH_INFO',
    data
  };
}

export function setUserProfile(data) {
  return {
    type: 'SET_USER_PROFILE',
    data
  };
}
